const useStyles = () => {
    return {

        headerAction: {
            flex: '0 1 220px',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'end',
            alignItems: 'center',
            gap: 1,
            '& .MuiSvgIcon-root': {
                fontSize: '30px'
            }
        },
        download: (disable:boolean) => ({
            color: disable ? 'grey':'primary.main',
            '& .MuiSvgIcon-root': {
                fontSize: '30px'
            }
        }),
        arrow: {
            padding: 0,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        },
        rotate: (expand: boolean) => ({
            transition: '200ms',
            transform: `rotate(${expand ? '180deg' : '0deg'})`,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        }),
    }
}

export { useStyles }